import React, { useState } from "react";
import { Dropdown, FormControl } from "react-bootstrap";

const SearchableSelect = ({ options, onChange, placeholder = "Select option",selectedRole }) => {
  const [search, setSearch] = useState("");

  // Filter + sort options
  const filteredOptions = options
    .filter((opt) => opt.label?.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => a.label.localeCompare(b));

  const handleSelect = (option,label) => {
    // setSelected(label);
    onChange(option);
    setSearch(""); // reset search when selecting
  };

  return (
    <Dropdown >
      <Dropdown.Toggle variant="outline-primary" id="dropdown-basic" className="text-start btn-filled-dark">
        {selectedRole || placeholder}
      </Dropdown.Toggle>

      <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: "250px", overflowY: "auto", }}>
        {/* Search box inside dropdown */}
        <FormControl
          autoFocus
          placeholder="Search..."
          className="mb-2"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{position:'sticky', top:'0px'}}
        />

        {/* Options */}
        {filteredOptions.length > 0 ? (
          filteredOptions.map((opt, idx) => (
            <Dropdown.Item key={idx} value={opt.value} onClick={(e) => handleSelect(opt.value,opt.label)}>
              {opt.label}
            </Dropdown.Item>
          ))
        ) : (
          <div className="px-3 py-2 text-muted">No options found</div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SearchableSelect;
